export const RequiredAsterisk = () => <span className="required-asterisk">*</span>;
